import { LOGICAL_ICON_TO_FA } from "./resolveNovidadeIcon.js";

const LEGACY_FA_ICONS = [
  { text: "fas fa-lock", value: "fas fa-lock" },
  { text: "fas fa-search", value: "fas fa-search" },
  { text: "fas fa-list", value: "fas fa-list" },
  { text: "fas fa-edit", value: "fas fa-edit" },
  { text: "fas fa-tachometer-alt", value: "fas fa-tachometer-alt" },
  { text: "fas fa-question-circle", value: "fas fa-question-circle" }
];

const LOGICAL_LABELS = {
  sparkles: "Sparkles (portal)",
  zap: "Zap",
  truck: "Truck",
  trendingup: "TrendingUp",
  tag: "Tag",
  shield: "Shield",
  package: "Package",
  bell: "Bell",
  dollarsign: "DollarSign",
  ticket: "Ticket",
  clock: "Clock",
  layers: "Layers",
  rocket: "Rocket",
  check: "Check",
  filetext: "FileText",
  search: "Search (lógico)",
  cart: "Cart",
  image: "Image",
  users: "Users"
};

function logicalOptions() {
  return Object.keys(LOGICAL_ICON_TO_FA).map(key => ({
    text: LOGICAL_LABELS[key] || key,
    value: LOGICAL_LABELS[key]?.replace(/\s*\(.*\)$/, "") || key,
    iconClass: LOGICAL_ICON_TO_FA[key]
  }));
}

/** Opções do seletor admin: FA legado + nomes lógicos do portal. */
export const NOVIDADES_ADMIN_ICON_OPTIONS = [
  { text: "Sem ícone", value: "", iconClass: "" },
  ...LEGACY_FA_ICONS.map(item => ({ ...item, iconClass: item.value })),
  ...logicalOptions()
];
